export const EDIT_MODES = {
    ADD: "add",
    MOVE: "move",
  };
  
  export const statesNames = {
    EXIT: "exit",
    PRE_RAY: {
      SELECTION: "preRay.selection",
      RECORDS: "preRay.records",
      CONFIG: "preRay.config",
    },
    RAY: {
      CONFIG: "ray.config",
      SELECTION: "ray.selection",
    },
    HISTORY: {
      ROOT: "history.root",
    },
    MANUAL_MESHING: {
      ROOT: "manualMeshing.root",
      ADD: "manualMeshing.add",
      MOVE: "manualMeshing.move",
    },
  };

  export const resources = {
    WINDOW_FILTERS: "windowFilters",
    WINDOW_SELECTION_BOX: "selectionBox",
    SELECTABLE_WINDOWS: "selectableWindows",
    ADD_MOVE_DELETE_MESHING_OPTIONS: "addMoveDeleteMeshingOptions",
    MANUAL_MESHING_PLACEMENT_CONTROLS: "manualMeshingPlacementControls",
    MANUAL_MESHING_ENABLED: "manualMeshingEnabled",
    ADD_MESHING_CONTROLS: "addMeshingControls",
    IS_ADDING_MESH: "isAddingMesh",
    MOVE_MESHING_CONTROLS: "moveMeshingControls",
    IS_MOVING_MESH: "isMovingMesh",
    SENSOR_ANALYSIS_CONTRAINER: "sensorAnalysisContainer",
    HISTORY_TAB: "historyTab",
    CONFIG_TAB: "configTab",
    RT_CONFIG_TAB: "rtConfigTab",
    RECORDS_TAB: "recordsTab",
    MANUAL_MESHING_TAB: "manualMeshingTab",
    WINDOW_SKYLINE_BUTTON: "windowSkylineButton",
    WINDOW_SELECTION_CONFIRMATION_BOX: "windowSelectionConfirmationBox",
  };

  export const actions = {
    ON_SUBMIT: "onSubmit",
    ON_NEXT: "onNext",
    ON_CLOSE: "onClose",
    ON_ADD: "ON_ADD",
    ON_ADD_MESH: "onAddMesh",
    ON_MOVE_MESH: "onMoveMesh",
    ON_NEW_REQUEST: "onNewRequest",
    ON_CANCEL: "onCancel",
    ON_RUN_PRE_RAY: "onRunPreRay",
    ON_RUN_RAY: "onRunRay",
    ON_GO_TO_SELECT_WINDOWS: "onGoToSelectWindows",
  };

  export const sensorAnalysisDefaultActiveTab = statesNames.HISTORY.ROOT;

  export const statesAndResources = {
    [statesNames.EXIT]: {
      resources: [],
    },
    [statesNames.PRE_RAY.SELECTION]: {
      resources: [
        resources.WINDOW_FILTERS,
        resources.WINDOW_SELECTION_BOX,
        resources.WINDOW_SELECTION_CONFIRMATION_BOX,
        resources.SELECTABLE_WINDOWS,
        resources.MANUAL_MESHING_TAB,
        resources.WINDOW_SKYLINE_BUTTON,
      ],
      [actions.ON_SUBMIT]: statesNames.PRE_RAY.RECORDS,
      [actions.ON_CANCEL]: statesNames.PRE_RAY.CONFIG,
      [actions.ON_CLOSE]: statesNames.EXIT,
    },
    [statesNames.PRE_RAY.RECORDS]: {
      resources: [resources.SENSOR_ANALYSIS_CONTRAINER, resources.RECORDS_TAB],
      [actions.ON_SUBMIT]: statesNames.HISTORY.ROOT,
      [actions.ON_CLOSE]: statesNames.EXIT,
      [actions.ON_ADD]: statesNames.PRE_RAY.SELECTION,
    },
    [statesNames.PRE_RAY.CONFIG]: {
      resources: [resources.SENSOR_ANALYSIS_CONTRAINER, resources.CONFIG_TAB],
      [actions.ON_SUBMIT]: statesNames.HISTORY.ROOT,
      [actions.ON_CLOSE]: statesNames.EXIT,
      [actions.ON_NEXT]: statesNames.PRE_RAY.RECORDS,
      [actions.ON_GO_TO_SELECT_WINDOWS]: statesNames.PRE_RAY.SELECTION,
    },
    [statesNames.RAY.CONFIG]: {
      resources: [
        resources.SENSOR_ANALYSIS_CONTRAINER,
        resources.RT_CONFIG_TAB,
      ],
      [actions.ON_SUBMIT]: statesNames.HISTORY.ROOT,
      [actions.ON_CLOSE]: statesNames.EXIT,
      [actions.ON_GO_TO_SELECT_WINDOWS]: statesNames.RAY.SELECTION,
    },
    [statesNames.RAY.SELECTION]: {
      resources: [
        resources.WINDOW_FILTERS,
        resources.WINDOW_SELECTION_BOX,
        resources.WINDOW_SELECTION_CONFIRMATION_BOX,
        resources.SELECTABLE_WINDOWS,
        resources.MANUAL_MESHING_TAB,
        resources.WINDOW_SKYLINE_BUTTON,
      ],
      [actions.ON_SUBMIT]: statesNames.RAY.CONFIG,
      [actions.ON_CANCEL]: statesNames.RAY.CONFIG,
      [actions.ON_CLOSE]: statesNames.EXIT,
    },
    [statesNames.HISTORY.ROOT]: {
      resources: [resources.SENSOR_ANALYSIS_CONTRAINER, resources.HISTORY_TAB],
      [actions.ON_NEW_REQUEST]: statesNames.PRE_RAY.CONFIG,
      [actions.ON_CLOSE]: statesNames.EXIT,
    },
    [statesNames.MANUAL_MESHING.ROOT]: {
      resources: [
        resources.WINDOW_FILTERS,
        resources.WINDOW_SELECTION_BOX,
        resources.ADD_MOVE_DELETE_MESHING_OPTIONS,
        resources.SELECTABLE_WINDOWS,
        resources.MANUAL_MESHING_TAB,
        resources.WINDOW_SKYLINE_BUTTON,
      ],
      [actions.ON_CLOSE]: statesNames.EXIT,
      [actions.ON_ADD_MESH]: statesNames.MANUAL_MESHING.ADD,
      [actions.ON_MOVE_MESH]: statesNames.MANUAL_MESHING.MOVE,
      [actions.ON_RUN_PRE_RAY]: statesNames.PRE_RAY.CONFIG,
      [actions.ON_RUN_RAY]: statesNames.RAY.CONFIG,
    },
    [statesNames.MANUAL_MESHING.ADD]: {
      resources: [
        resources.WINDOW_FILTERS,
        resources.WINDOW_SELECTION_BOX,
        resources.SELECTABLE_WINDOWS,
        resources.ADD_MOVE_DELETE_MESHING_OPTIONS,
        resources.MANUAL_MESHING_PLACEMENT_CONTROLS,
        resources.MANUAL_MESHING_ENABLED,
        resources.MANUAL_MESHING_TAB,
        resources.ADD_MESHING_CONTROLS,
        resources.IS_ADDING_MESH,
        resources.WINDOW_SKYLINE_BUTTON,
      ],
      [actions.ON_CLOSE]: statesNames.MANUAL_MESHING.ROOT,
      [actions.ON_SUBMIT]: statesNames.MANUAL_MESHING.ROOT,
      [actions.ON_CANCEL]: statesNames.MANUAL_MESHING.ROOT,
    },
    [statesNames.MANUAL_MESHING.MOVE]: {
      resources: [
        resources.WINDOW_FILTERS,
        resources.WINDOW_SELECTION_BOX,
        resources.SELECTABLE_WINDOWS,
        resources.ADD_MOVE_DELETE_MESHING_OPTIONS,
        resources.MANUAL_MESHING_PLACEMENT_CONTROLS,
        resources.MANUAL_MESHING_ENABLED,
        resources.MANUAL_MESHING_TAB,
        resources.MOVE_MESHING_CONTROLS,
        resources.IS_MOVING_MESH,
        resources.WINDOW_SKYLINE_BUTTON,
      ],
      [actions.ON_CLOSE]: statesNames.MANUAL_MESHING.ROOT,
      [actions.ON_SUBMIT]: statesNames.MANUAL_MESHING.ROOT,
      [actions.ON_CANCEL]: statesNames.MANUAL_MESHING.ROOT,
    },
  };